import React from 'react';
import { Grid, IconButton } from '@material-ui/core';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import PropTypes from 'prop-types';
import ReplayIcon from '@material-ui/icons/Replay';
import Tooltip from '@material-ui/core/Tooltip';

const TableActions = ({ row, deleteFile, retryProcess }) => {
    const { analyzerStatus } = row;
    return (
        <Grid
            container
            direction="row"
            justifyContent="space-evenly"
            alignItems="center"
        >
            <Grid item style={{ width: '28px' }}>
                {analyzerStatus === 'error' && (
                    <Tooltip title="Retry" placement="top" key={'info'}>
                        <IconButton aria-label={'retry'} onClick={retryProcess}>
                            <ReplayIcon color="primary" />
                        </IconButton>
                    </Tooltip>
                )}
            </Grid>
            <Grid item>
                <Tooltip title="Delete file" placement="top" key={'info'}>
                    <IconButton aria-label={'delete-file'} onClick={deleteFile}>
                        <DeleteForeverIcon style={{ color: 'red' }} />
                    </IconButton>
                </Tooltip>
            </Grid>
        </Grid>
    );
};

export default TableActions;

TableActions.propTypes = {
    row: PropTypes.objectOf(PropTypes.any).isRequired,
    deleteFile: PropTypes.func.isRequired,
    retryProcess: PropTypes.func.isRequired,
};
